import { campaignBillingStatus } from 'constants/campaignConstants';

const isFailedBilling = (status) => {
  return status === campaignBillingStatus.FAILED;
};

export default isFailedBilling;
